import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { TaxSuccessAmountLabelComponent } from "./tax-success-amount-label.component";
import { TaxAmountLabelComponent } from "./tax-label.component";

@NgModule({
	declarations: [TaxSuccessAmountLabelComponent, TaxAmountLabelComponent],
	exports: [TaxSuccessAmountLabelComponent],
	imports: [CoreModule]
})
export class TaxSuccessAmountLabelModule {}
